const condition = [
  {
    conditionId: '1',
    categoryId: 1,
    conditionName: 'HELLP Syndrome'
  },
  {
    conditionId: '2',
    categoryId: 1,
    conditionName: 'Edema with proteinuria'
  },
  {
    conditionId: '3',
    categoryId: 1,
    conditionName: 'Gestational hypertension asdasda asdasd asdasd asdasd'
  },
  {
    conditionId: '4',
    categoryId: 2,
    conditionName: 'Eclampsia'
  },
  {
   conditionId: '5',
   categoryId: 2,
   conditionName: 'Varlcose veins of lower extremity'
  }
];

export default {
  condition
}


